
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.1742 8.6387L5.32945 15.4853C5.31282 15.5019 5.30338 15.5246 5.30335 15.5483L5.30028 18.6985L8.45586 18.7C8.47919 18.7 8.50167 18.6907 8.51832 18.6741L15.3626 11.828L12.1742 8.6387ZM16.6352 10.555L13.4468 7.36573L15.392 5.41996L18.5805 8.60924L16.6352 10.555ZM16.4603 3.94263C15.8703 3.35246 14.9137 3.35246 14.3237 3.94263L4.05649 14.2126C3.70277 14.5664 3.50384 15.0462 3.50335 15.5465L3.5 18.9857C3.49919 19.8206 4.17541 20.498 5.0101 20.4984L8.45501 20.5C8.95619 20.5002 9.4369 20.3012 9.79128 19.9467L20.0574 9.67784C20.6474 9.08767 20.6474 8.13082 20.0574 7.54065L16.4603 3.94263Z","fill":"#16171F"}})])
          )
        }
      }
    